import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {RouterModule} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {MainPagesContainerComponent} from '../main-pages-container/main-pages-container.component';

@Component({
    selector: 'app-qa',
    templateUrl: './qa.component.html',
    styleUrls: ['../main.pages.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MainPagesContainerComponent,
        MatButtonModule,
        RouterModule,
        TranslatePipe
    ]
})
export class QaComponent {
}
